var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "billing" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            "show-trial-remain-day": true,
            paths: [{ title: _vm.$t("billing.billingPlanSettings") }],
            select: true,
          },
        },
        [
          _vm.isAdmin
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.invoice-form",
                      modifiers: { "invoice-form": true },
                    },
                  ],
                  staticClass: "actionButtonBreadcrumb",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("billing.newInvoice")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [_c("DefaultBillingSettings")],
        1
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }